import { fetch } from "@/services/catalogService/courses";
import { fetch as fetchUnauth } from "@/services/unauthService/courses";
import { isScormContent } from "@/utils/isScormContent";
import isUnauth from "@/utils/isUnauth";

/**
 * Returns the pathname and search string from document.referrer if it's
 * same-origin, or null otherwise. Used as a fallback when Vue Router's
 * _from is empty (e.g. unauth full-reload via globalThis.location.href).
 */
export function getSameOriginReferrerLocation(): {
  pathname: string;
  search: string;
} | null {
  try {
    const referrer = document.referrer;
    if (!referrer) return null;
    const referrerUrl = new URL(referrer);
    if (referrerUrl.origin === globalThis.location.origin) {
      return {
        pathname: referrerUrl.pathname,
        search: referrerUrl.search,
      };
    }
  } catch {
    // Invalid URL — ignore
  }
  return null;
}

export async function getCourseRouteDetails(to: any) {
  const courseId = to.params.courseId;
  let c1 = false;
  let c2 = false;
  let isScorm = false;
  let courseData: any = null;
  let route: any = {};
  let url = "";
  route = {
    name: "explore-courses",
  };
  try {
    const data = isUnauth()
      ? await fetchUnauth(courseId, true)
      : await fetch(courseId, true);

    courseData = data;

    // Check if this is SCORM content
    if (isScormContent(data)) {
      isScorm = true;
    } else if (data.active === 0 || (isUnauth() && data?.tracks?.length > 0)) {
      c1 = true;
    } else if (!isUnauth() && data?.tracks?.length > 0) {
      c2 = true;
      url = data.catalog_data ? data.catalog_data.url : data.url;
      if (!url || url === "") {
        c1 = true;
        c2 = false;
      }
    }
  } catch (error) {
    if (!import.meta.env.TEST) {
      console.error("Error fetching course data:", error);
    }
  }

  return { c1, c2, isScorm, courseData, route, url };
}
